import { useField } from 'react-final-form';
import { useTranslator } from '@gandi/translate';
export const useFieldError = name => {
  const {
    meta
  } = useField(name,
  // $FlowFixMe[prop-missing] FinalForm's UseFieldConfig definition isn't compatible with exact_by_default
  {
    subscription: {
      error: true,
      submitError: true,
      submitFailed: true,
      touched: true,
      dirtySinceLastSubmit: true
    }
  });
  const showSubmitError = meta.submitError && meta.submitFailed && !meta.dirtySinceLastSubmit;
  if (showSubmitError) {
    // display the submit error in first place until the field becomes dirty
    return meta.submitError;
  }
  const showError = !!meta.error && meta.touched;
  return showError ? meta.error : undefined;
};
export const useBasicValidators = () => {
  const {
    __
  } = useTranslator();
  return {
    required: value => value?.toString().trim().length ? undefined : __('Required')
  };
};